export interface UpdateSystemConfigRequest {
  value: string
  revision: number
}

export function UpdateSystemConfigRequestToJSON(
  value: UpdateSystemConfigRequest
): any {
  return {
    value: value.value,
    revision: value.revision
  }
}
